var map = {
	"./BOU/packaged.png": "ed9d",
	"./DRU/packaged.png": "927f",
	"./FNB/packaged.png": "1bda",
	"./HIM/packaged.png": "b624",
	"./OTH/packaged.png": "16ed",
	"./SUP/packaged.png": "30f9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dbf1";